import React from 'react'
// components
import MinimizedObjectivesList from 'components/PageComponents/Plans/Edit/components/MinimizedObjectivesList/index'
// context
import MinimizedObjectivesListAPI from 'containers/MinimizedObjectivesList/layers/API'
import MinimizedObjectivesListActions from 'containers/MinimizedObjectivesList/layers/Business/Actions'
import SelectedPlanItems from 'containers/SubPlan/layers/BL/SelectedItems'
import DetailsModalActions from 'containers/MinimizedObjectivesList/layers/Business/DetailsModalActions'

const MinimizedObjectivesListContainer: React.FunctionComponent<any> = ({ isObjectivesModal, ...props }) => (
  <MinimizedObjectivesListAPI isObjectivesModal={isObjectivesModal}>
    <SelectedPlanItems>
      <MinimizedObjectivesListActions>
        <DetailsModalActions>
          <MinimizedObjectivesList {...props} />
        </DetailsModalActions>
      </MinimizedObjectivesListActions>
    </SelectedPlanItems>
  </MinimizedObjectivesListAPI>
)

export default MinimizedObjectivesListContainer
